import { render, staticRenderFns } from "./UserSelectListItem.vue?vue&type=template&id=dce6a8c4&scoped=true&"
import script from "./UserSelectListItem.vue?vue&type=script&lang=js&"
export * from "./UserSelectListItem.vue?vue&type=script&lang=js&"
import style0 from "./UserSelectListItem.vue?vue&type=style&index=0&id=dce6a8c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce6a8c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListItemContent})
